export default {
  loadingScreenHide: "LOADING_SCREEN_HIDE",
  backgroundImagesLoaded: "BACKGROUND_IMAGES_LOADED",
  loadingScreenAnimationEnded: "LOADING_SCREEN_ANIMATION_ENDED",
  deviceDetection: "DEVICE_DETECTION",
  changeMoveDirection: "CHANGE_MOVE_DIRECTION",

  changeActiveHouseInformationWindow: "CHANGE_ACTIVE_HOUSE_INFORMATION_WINDOW",
  windowWithSliderContentChange: "WINDOW_WITH_SLIDER_CONTENT_CHANGE",
  showVideo: "SHOW_VIDEO",
  showPanoramas: "SHOW_PANORAMAS",
  hidePanoramas: "HIDE_PANORAMAS"
};
